// src/components/SidebarComponent.js

// Importing necessary libraries and components from react-bootstrap, react-icons, and react-router-dom
import React, { useState } from 'react';
import { Card, Button } from 'react-bootstrap'; // Importing Card and Button from react-bootstrap for UI components
import { FaTachometerAlt, FaRegChartBar, FaEnvelope, FaHistory } from 'react-icons/fa'; // Importing icons from react-icons
import { Link } from 'react-router-dom'; // Importing Link from react-router-dom for navigation
import axios from 'axios'; // Importing axios to make API calls

// SidebarComponent is a functional component that receives userDetails as a prop
const SidebarComponent = ({ userDetails }) => {
  const [isApiCalled, setIsApiCalled] = useState(false);

  // Function to make the API call when the plan button is clicked
  const handlePlanButtonClick = async () => {
    if (userDetails?.referralCode && userDetails?.balance >= 20 && !isApiCalled) {
      try {
        // Make the API call to send data
        const response = await axios.post('https://sharedvision-partners.online/v1/API/referrerTrans.php', {
          referralCode: userDetails.referralCode,
          balance: userDetails.balance,
          email: userDetails.email,
        });

        // Handle response here if needed
        console.log('API response:', response.data);

        // After the API call, set the flag to prevent further API calls
        setIsApiCalled(true);
      } catch (error) {
        console.error('Error making API call:', error);
      }
    }
  };

  return (
    // Card component to create a container for the sidebar
    <Card className="shadow-sm mb-4">
      <Card.Header>Welcome</Card.Header> {/* Title of the sidebar */}
      <Card.Body>
        {/* Displaying user information: Email and balance details */}
        <p><strong>{userDetails ? userDetails.email : 'Loading...'}</strong></p>
                {/* If userDetails exists, display user's email and balances, else show 'Loading...' */}
        <p>Available Balance: <strong>${userDetails ? userDetails.balance : 'Loading...'}</strong></p>
        <p>Withdrawable Balance: <strong>${userDetails ? userDetails.expectedWithdrawal : 'Loading...'}</strong></p>
              {/* Dashboard button with icon and link */}
        <Button variant="primary" className="mb-3 w-100" as={Link} to="/dashboard">
          <FaTachometerAlt className="mr-2" /> {/* Icon for Dashboard */}
          Dashboard
        </Button>
        
        {/* Plan button with icon and link */}
        <Button 
          variant="primary" 
          className="mb-3 w-100" 
          as={Link} 
          to="/dashboard/plan"
          onClick={handlePlanButtonClick} // Trigger the API call when Plan is clicked
        >
          <FaTachometerAlt className="mr-2" /> {/* Icon for Plan */}
          Plan
        </Button>
        
        {/* Reports button with icon and link */}
        <Button variant="secondary" className="mb-3 w-100" as={Link} to="/dashboard/reports">
          <FaRegChartBar className="mr-2" /> {/* Icon for Reports */}
          Reports
        </Button>

        {/* History button with icon and link */}
        <Button variant="success" className="mb-3 w-100" as={Link} to="/dashboard/history">
          <FaHistory className="mr-2" /> {/* Icon for History */}
          History
        </Button>

        {/* Messages button with icon and link */}
        <Button variant="success" className="mb-3 w-100" as={Link} to="/dashboard/messages">
          <FaEnvelope className="mr-2" /> {/* Icon for Messages */}
          Messages
        </Button>

        {/* Top Up button with link */}
        <Button variant="warning" className="mb-3 w-100" as={Link} to="/dashboard/topup">
          Top Up
        </Button>

        {/* Withdraw button with link */}
        <Button variant="danger" className="mb-3 w-100" as={Link} to="/dashboard/withdraw">
          Withdraw
        </Button>
        
      </Card.Body>
    </Card>
  );
};

// Exporting SidebarComponent as the default export of the module
export default SidebarComponent;
